const Card = ({ children, className = '', title, action }) => {
  return (
    <div
      className={`rounded-[20px] border border-stone-200 bg-white shadow-[0_14px_34px_-30px_rgba(28,25,23,0.3)] ${className}`}
    >
      {(title || action) && (
        <div className="flex flex-col gap-2.5 border-b border-stone-200 px-4 py-3.5 sm:flex-row sm:items-center sm:justify-between sm:px-5">
          {title && (
            <h3 className="min-w-0 text-base font-semibold leading-6 tracking-tight text-stone-950">
              {title}
            </h3>
          )}
          {action && <div className="shrink-0">{action}</div>}
        </div>
      )}
      <div className="px-4 py-4 sm:px-5">{children}</div>
    </div>
  );
};

export default Card;
